import { Component, OnInit, Input } from '@angular/core';
import { Retencion } from '../../../models/retencion';
import { RetencionService } from '../../../services/retencion.service';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Validation } from '../../../config/validation';

@Component({
	selector: 'retencion-compra-modal',
	templateUrl: './retencion-compra-modal.component.html',
    styleUrls: ['./retencion-compra-modal.component.css'],
    providers: [RetencionService]
})
export class RetencionCompraModalComponent implements OnInit {
    @Input() retencion_id: String;
    public retencion: Retencion;
    public total: number;
    public loading = false;
    public vl: Validation;

    constructor(
        private retencionService: RetencionService,
        public bsModalRef: BsModalRef,
    ){
        this.retencion = new Retencion();
        this.total = 0;
        this.vl = new Validation();
    }

    ngOnInit(){
        this.getRetencionById();
    }

    getRetencionById(){
        this.loading = true;
        let qs = "?embed=tipocomprobante,detalle?embed=impuesto,compra?embed=bodega;proveedor";
        this.retencionService.getById(this.retencion_id, qs).subscribe(
            res => {
                this.loading = false;
                this.retencion = res;
                this.total = 0;
                this.retencion.detalle.forEach(x => this.total += parseFloat(x.total.toString()));
            },
            err => {
                this.loading = false;
            }
        );
    }

    getNumeroDocumento(retencion){
		return retencion.serie + "-" + retencion.punto_emision + "-" + retencion.secuencial;
    }
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/retencion-compra-modal/retencion-compra-modal.component.ts